<div #wrapper class="diary-training-wrapper">
    <app-modal-header [text]="'diary_training' | localise" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <div class="modal-body" [ngClass]="isIOS() === true ? 'ios' : ''">
        <ng-container *ngIf="hasCustomDailyTrainings === false">
            <h2 class="title-bg">{{ 'diary_planned_trainings' | localise }}</h2>

            <ol class="planned-trainings">
                <ng-container *ngFor="let training of trainings">
                    <ng-container *ngFor="let item of trainingActivities">
                        <li *ngIf="isToday(training.day) && training.training_activity && item.id === training.training_activity.id"
                            [ngStyle]="{textDecoration: (showEnableTrainingTodayBtn() ? 'line-through': '')}">
                            {{ training.training_activity.title }}

                            <ng-container *ngFor="let duration_item of trainingDurations">
                                <span *ngIf="training.training_duration && duration_item.id === training.training_duration.id">
                                    - {{ training.training_duration.duration | minutesToReadableTime }}
                                    ({{ 'active_part' | localise }})
                                </span>
                            </ng-container>

                        </li>
                    </ng-container>
                </ng-container>
            </ol>

            <div class="row training-actions-row">
                <div class="col-sm-12 col-md-12 col-xs-12 text-align-center">
                    <button (click)="hasCustomDailyTrainings = true"
                            class="btn btn-sm btn-secondary edit-planned-trainings add-new-training">
                        <i class="ti-pencil"></i>
                        {{ 'diary_planned_trainings_change' | localise }}
                    </button>

                    <button
                            *ngIf="showDisableTrainingTodayBtn()"
                            (click)="disableTrainingToday()"
                            class="btn btn-sm btn-secondary disable-planned-trainings add-new-training">
                        <i class="ti-close"></i>
                        {{ 'disable_training_today' | localise }}
                    </button>

                    <button
                            *ngIf="showEnableTrainingTodayBtn()"
                            (click)="disableTrainingToday()"
                            class="btn btn-sm btn-secondary disable-planned-trainings enable-planned-trainings add-new-training">
                        <i class="ti-plus"></i>
                        {{ 'enable_training_today' | localise }}
                    </button>
                </div>
            </div>
        </ng-container>

        <div
                *ngIf="hasCustomDailyTrainings"
                class="form-group">

            <ng-container *ngFor="let training of trainings; let i = index">
                <div class="row training-row" *ngIf="isToday(training.day)">

                    <div class="col-sm-12 col-md-12 training-day">
                        <button class="btn btn-sm btn-danger" (click)="removeTraining(i)"><i class="ti-close"></i>
                        </button>
                        <button class="btn btn-sm btn-primary" (click)="duplicateTraining(i)">
                            <i class="fa fa-copy"></i>
                        </button>

                        <select (change)="onTrainingChange($event, i)" class="form-control">
                            <option value="">{{ 'TRAINING' | localise }}</option>
                            <option
                                    *ngFor="let item of trainingActivities"
                                    [selected]="training.training_activity && item.id === training.training_activity.id"
                                    [value]="item.id">
                                {{ item.title }}
                            </option>
                        </select>

                        <select (change)="onDurationChange($event, i)" class="form-control">
                            <option value="">{{ 'DURATION' | localise }}</option>
                            <option
                                    *ngFor="let item of trainingDurations"
                                    [selected]="training.training_duration && item.id === training.training_duration.id"
                                    [value]="item.id">
                                {{ item.duration | minutesToReadableTime }} ({{ 'active_part' | localise }})
                            </option>
                        </select>
                    </div>
                </div>
            </ng-container>

            <div class="row">
                <div class="col-sm-12 col-md-12 col-xs-12 text-align-center">
                    <button (click)="addTraining()" class="btn btn-sm btn-success add-new-training">
                        <i class="ti-plus"></i>
                        {{ 'add_new_training' | localise }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer" [ngClass]="isIOS() === true ? 'ios' : ''" *ngIf="hasCustomDailyTrainings">
        <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">{{ 'back' | localise }}</button>
        <button type="button" class="btn btn-success" (click)="save()">{{ 'save' | localise }}</button>
    </div>
</div>
